import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Toast from "../../components/Toast";
class ListFranchiseScreen extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [],
      toast : {
        show: false,
       message:"",
        type: "success",
      },
     };
  }
  componentDidMount() {
    this.getBlogs();
  }

  getBlogs = async () => {
    const data = await API(this, "get", URL_PATH.listBlog);
    //console.table(data);
    this.setState({ data });
    // console.log(JSON.stringify(data));
  };
  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  };

  deleteBlog = async (id) => {
    const result = await API(this, "delete", URL_PATH.deleteBlog(id), null);
    if (result) {
      this.getBlogs();
      this.showToast("Blog Deleted Successfully", "success");
     
    }
  };

  render() {
    const { data } = this.state;
    return (
      <div className="container">
        <h1>Blogs</h1>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Id</th>
              <th>Title</th>

              <th>Updated At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((blog) => (
              <tr key={blog.id}>
                <td>{blog.id}</td>
                <td>{blog.title}</td>
                <td>{blog.updated_at}</td>
                <td>
                  {/* <Link className="btn btn-primary m-1">
                                        Show
                                    </Link> */}
                  {/* <Link className="btn btn-primary m-1">
                                        Edit
                                    </Link> */}
                  <Link
                    onClick={() =>
                      window.Alert(
                        {
                          title: "delete",
                          text: "are you sure you want to delete this Home screen Tile",
                          showCancelButton: true,
                        },
                        () => {
                          this.deleteBlog(blog.id);
                        }
                      )
                    }
                    className="btn btn-danger m-1"
                  >
                    Delete
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default redux(ListFranchiseScreen);
